/**
 * 战斗系统类型定义
 * 包含战斗状态（持久化部分）
 */

import { z } from 'zod';

// ============================================
// 战斗状态
// ============================================

/**
 * 战斗类型
 */
export const BattleTypeSchema = z.enum(['normal', 'boss', 'event']);
export type BattleType = z.infer<typeof BattleTypeSchema>;

/**
 * 战斗状态（持久化部分）
 * 注意：完整的战斗状态在运行时管理，这里只存需要持久化的
 */
export const PersistentBattleStateSchema = z.object({
  isActive: z.boolean().default(false),
  battleId: z.string().optional(),
  battleType: BattleTypeSchema.optional(),
  // 战斗上下文（用于恢复）
  context: z
    .object({
      returnLocation: z.string().optional(),
      explorationContext: z
        .object({
          explorationId: z.string(),
          nodeId: z.string(),
        })
        .optional(),
    })
    .optional(),
});

export type PersistentBattleState = z.infer<typeof PersistentBattleStateSchema>;

// ============================================
// 战斗奖励
// ============================================

export interface BattleRewards {
  gold: number;
  items?: { id: string; name: string }[];
}

// ============================================
// 类型守卫函数
// ============================================

/**
 * 检查是否为有效的战斗类型
 */
export function isValidBattleType(value: unknown): value is BattleType {
  return BattleTypeSchema.safeParse(value).success;
}
